export default __webpack_public_path__ + "static/media/Hand-wraps of the Crawling Chaos.e274fcb8.jpg";